const toLocalDateValue = (date) => {
  const pad = (value) => String(value).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
};

export const getDefaultWeekRange = () => {
  const to = new Date();
  const from = new Date(to);
  from.setDate(from.getDate() - 6);
  return { fromDate: toLocalDateValue(from), toDate: toLocalDateValue(to) };
};

export const getDateRangeParams = (fromDate, toDate) => ({
  ...(fromDate ? { from_date: fromDate } : {}),
  ...(toDate ? { to_date: toDate } : {}),
});
